import { Component, OnInit, Input } from '@angular/core';
import { Breakdown } from 'src/app/model/quote/breakdown/breakdown.model';
import {BreakdownService} from "../../breakdown.service";
import { QuoteService } from '../../../quote.service';
import { environment } from '../../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-breakdown-overview',
  templateUrl: './breakdown-overview.component.html',
  styleUrls: ['./breakdown-overview.component.css', '../../../quote.component.css']
})
export class BreakdownOverviewComponent implements OnInit {
  public quote;
  public quoteApplicationData = new Breakdown();
  public cover_to: Date;
  public cover_from: Date;
  public BREAKDOWN_ID = '';
  public isAdmin = false;
  public brokers: any[] = [];
  public brokerName: string = 'Peliwica Limited';
  
  @Input() set quoteDetails(value: any) {
    const isEmpty = Object.keys(value).length === 0;
    console.log(value);
    if (!isEmpty) {
      this.quote = value;
      this.quoteApplicationData = value;

      this.cover_from = new Date(value.inception_date);
      this.cover_to = new Date(value.policy_end_date);

      if(this.quote.policy_holder_detail.proposer_type === 1){ 
        const dob = this.quote.policy_holder_detail.dob.split(' ')[0];
        this.quote.policy_holder_detail.dob = dob;
      }
      console.log('proposer type: ', value.policy_holder_detail?.proposer_type);

      const proposerType = value.policy_holder_detail?.proposer_type;
      switch(proposerType) {
        case 1:
        case '1':
        case 'individual':
          this.quote.policy_holder_detail.proposer_type = 'individual';
          break;
        case 2:
        case '2':
        case 'company':
          this.quote.policy_holder_detail.proposer_type = 'company';
          break;
        case 3:
        case '3':
        case 'joint':
          this.quote.policy_holder_detail.proposer_type = 'joint';
          break;
      }
      
      // Find broker name when quote details are set
      // If brokers are already loaded, find it now, otherwise it will be found when brokers load
      if (this.brokers.length > 0) {
        this.findBrokerName();
      }
    }
  }

  constructor(
    private sessionSt: LocalStorageService,
    private quoteService: QuoteService
  ) { }


  isMicroEnterpriseYes(): boolean {
    const ph = this.quote?.policy_holder_detail;
    if (!ph) return false;
    const v = ph.is_micro_enterprise ?? ph.micro_enterprise;
    return v === 1 || v === true || v === '1';
  }

  ngOnInit(): void {
    // this.UK_HB_INSURANCE_COMPANY_ID = environment.UK_HB_INSURANCE_COMPANY_ID;
    this.BREAKDOWN_ID = environment.BREAKDOWN_ID;

    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    
    // Fetch brokers list
    this.getBrokers();
  }

  getProposerType(): string { 
    return this.quote?.policy_holder_detail?.proposer_type ?? '';
  }

  getBrokers() {
    this.quoteService.getBrokers(6) // Product type 6 for breakdown
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.brokers = response.result;
            // Once brokers are loaded, find the broker name for the quote
            this.findBrokerName();
          }
        },
        (error) => {
          console.error('Error fetching brokers:', error);
        }
      );
  }

  findBrokerName() {
    if (this.quote && this.quote.company_id && this.brokers.length > 0) {
      const broker = this.brokers.find(b => b.id === this.quote.company_id);
      if (broker) {
        this.brokerName = broker.name;
      } else {
        // Fallback to company_name if broker not found
        this.brokerName = this.quote.company_name || 'Peliwica Limited';
      }
    } else if (this.quote && this.quote.company_name) {
      this.brokerName = this.quote.company_name;
    }
  }

}
